import { toast } from "components/toastNotification";
import { useQueryClient, useMutation } from "react-query";
import { deactivateOfficeApplianceById } from "../api/officeApplianceService";

export const useDeactivateOfficeAppliance = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    (officeApplianceIds: number[] | undefined) =>
      deactivateOfficeApplianceById(officeApplianceIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetOfficeAppliance"]);
        queryClient.invalidateQueries(["OfficeApplianceByOfficeId"]);
        toast.fire(
          "Success",
          "Office Appliance were deactivated successfully",
          "success"
        );
      },
      onError: () => {
        toast.fire(
          "Bulk deactivation of Office Appliance failed",
          "Server Error: Cannot deactivate Office Appliance",
          "error"
        );
      },
    }
  );
  return mutate;
};
